import { onBeforeUpdate as _onBeforeUpdate } from "gyron";
import { h as _h } from "gyron";
import { FC } from 'gyron';
import { useRouter } from '@gyron/router';
import { Header } from '@/components/header';
import { isUesLightTheme } from '@/hooks/light';
import classnames from 'classnames';
export const Layout = FC(({
  lang,
  children
}) => {
  // Auxiliary update of deconstructed props
  _onBeforeUpdate((_, props) => {
    var _props = props;
    lang = _props.lang;
    children = _props.children;
  })
  const router = useRouter();
  return ({
    lang,
    children
  }) => _h("div", {
    "class": classnames('text-slate-500 dark:text-slate-400 bg-slate-50 dark:bg-slate-900', {
      'background-linear': true,
      'background-linear-full': isUesLightTheme(router.path)
    })
  }, [_h(Header, {
    "lang": lang
  }, []), _h("div", {
    "class": "flex flex-col lg:m-auto lg:max-w-[90rem]"
  }, _h("div", {
    "class": classnames('overflow-hidden')
  }, children))]);
});